import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import { useNavigate } from "react-router-dom";
import DynamicPageLayout from "../common/DynamicPageLayout";
import { DataGridComponent } from "../common/DataGridComponent";
import { useEnrollmentDetails } from "./useEnrollmentDetails";

const EnrollmentDetails: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();

  const {
    patientDetailsContentJson,
    patientDetailsDataContentJson,
    enrollmentDetailscolumns,
  } = useEnrollmentDetails();

  const actions = {
    actionsColumn: {
      action_edit: (data: any) => {
        // console.debug(data);
      },
      action_delete: (data: any) => {
        //console.debug(data)
      },
    },
  };

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => navigate("/enrollment")}
        >
          Back
        </Button>
      </Box>
      <Grid container spacing={2} mb={2}>
        <Grid item xs>
          <Typography variant="h5">Patient 3333-222</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item md={3}>
          <Box sx={{ ml: -2 }}>
            <DynamicPageLayout
              pageContentJson={patientDetailsContentJson}
              data={{}}
            />
          </Box>
        </Grid>
        <Grid item md={9}>
          <DynamicPageLayout
            pageContentJson={patientDetailsDataContentJson}
            data={{}}
          />
          <br />
          <Typography variant="h6" gutterBottom>
            Sample List
          </Typography>
          <DataGridComponent
            autoHeight
            columns={enrollmentDetailscolumns as any}
            hasDefinedColumns={false}
            rows={[
              {
                id: "B123",
                sampleType: "FFPE Block",
                specimenType: "Core Needle",
                collectionDate: "04-10-2024",
                info: "Cell",
              },
            ]}
            showQuickFilter
            actions={actions}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default EnrollmentDetails;
